<nav class="mobile-bottom-nav">
  <div class="mobile-bottom-nav-container">
    <a class="nav-item" [routerLink]="['/service']" routerLinkActive="active">
      <app-icon name="CircleQuestionMark" size="lg" />
      <span class="nav-label">{{ "common.dictionary.help" | translate }}</span>
    </a>

    <button class="nav-item category-nav-item" (click)="toggleCategoryMenu()">
      <app-icon name="Menu" size="lg" />
      <span class="nav-label">{{ "common.dictionary.categories" | translate }}</span>
      <app-mobile-category-drawer #categoryDrawer [categoryList]="navigationCategories()" />
    </button>

    <a class="nav-item" [routerLink]="['/cart']" routerLinkActive="active">
      <app-button-badge [count]="cartCount$ | async">
        <app-icon name="ShoppingCart" size="lg" />
      </app-button-badge>
      <span class="nav-label">{{ "common.action.cart" | translate }}</span>
    </a>

    <a class="nav-item" [routerLink]="['/favorite-products']" routerLinkActive="active">
      <app-button-badge [count]="favoriteProducts().length">
        <app-icon name="Heart" size="lg" />
      </app-button-badge>
      <span class="nav-label">{{ "common.action.favorites" | translate }}</span>
    </a>

    <button class="nav-item account-nav-item" (click)="toggleAccountMenu()">
      <app-icon name="UserRound" size="lg" />
      <span class="nav-label">{{ "common.action.my_account" | translate }}</span>
      <app-mobile-account-drawer #accountDrawer />
    </button>
  </div>
</nav>
